import { connect } from 'react-redux'
import FormAppraisalsView from './AppraisalForm.comonent'
import { submitForm, resetForm } from '../../../../actions/appraisals'

const mapStateToProps = (state) => {
  return {
    send: state.appraisals.send
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmitAppraisalForm: value => dispatch(submitForm(value)),
    resetContactForm: () => dispatch(resetForm())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormAppraisalsView)



// WEBPACK FOOTER //
// ./src/features/PageAppraisals/components/AppraisalForm/AppraisalForm.container.js